export const tokenAddress = {
  1: '0xf5cfbc74057c610c8ef151a439252680ac68c6dc',
  3: '0xe29BF7D9A28916fABe71Cb195E3F2b77B52f7144'
}

export const multiVestingContractAddress = '0x1137B822E16fA45916569337Ee5D6367149E11e9';